import { Link } from "react-router-dom";
import { categoryMeta } from "@/mocks/articles";

const shortcuts = [
  {
    ...categoryMeta.news,
    desc: "影视、音乐、综艺与行业要闻一网打尽",
    color: "bg-primary-100 text-primary-700",
  },
  {
    ...categoryMeta.recommendations,
    desc: "精选片单，帮你找到下一部想看的作品",
    color: "bg-accent-100 text-accent-900",
  },
  {
    ...categoryMeta.stars,
    desc: "追踪热门明星的行程与最新报道",
    color: "bg-secondary-100 text-secondary-900",
  },
];

export default function CategoryShortcuts() {
  return (
    <section aria-label="内容分类入口" className="grid grid-cols-1 gap-4 sm:grid-cols-3">
      {shortcuts.map((item) => (
        <Link
          key={item.slug}
          to={`/category/${item.slug}`}
          className="card-hover group flex items-center gap-4 rounded-lg border border-background-200 bg-background-50 p-5"
        >
          <span
            className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-lg ${item.color}`}
          >
            <i className={`${item.icon} text-2xl`} />
          </span>
          <div className="min-w-0">
            <h3 className="flex items-center gap-1 text-base font-semibold text-foreground-950">
              {item.name}
              <i className="ri-arrow-right-line text-foreground-400 transition-transform group-hover:translate-x-0.5" />
            </h3>
            <p className="mt-1 line-clamp-1 text-xs text-foreground-600">{item.desc}</p>
          </div>
        </Link>
      ))}
    </section>
  );
}